import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import { Box, Stack, Typography } from "@mui/material";
import { PrimaryButton } from "../../../../components/form";
import { AllPastTimesMessageProps } from "./types";

export function AllPastTimesMessage({ onSwitchToSuggestTime }: AllPastTimesMessageProps) {
  return (
    <Box borderRadius={1.5} px={2} py={2}>
      <Stack gap={1.5} alignItems="center">
        <AccessTimeOutlinedIcon color="warning" />
        <Typography variant="body2" color="text.primary" textAlign="center" fontWeight={600}>
          All scheduled times have expired and are no longer available for selection.
        </Typography>
        <Typography variant="body2" color="text.secondary" textAlign="center">
          Please suggest alternative times that work for you.
        </Typography>
        {onSwitchToSuggestTime && (
          <PrimaryButton onClick={onSwitchToSuggestTime} size="small">
            Suggest time
          </PrimaryButton>
        )}
      </Stack>
    </Box>
  );
}
